import { Actions } from './Types';
import ServiceProfile from '../../Services/ServiceProfile';
import { IPageOptions } from '../../Models/Common';

const service = new ServiceProfile();

const createActionRequest = () => ({
	type: Actions.REQUESTING_PROFILE
});



export const createActionFetchProfile = (id: number) => {
	return (dispatch: any) => {
		dispatch(createActionRequest())
		service.fetch(id)
			.then(async r => {
				const data = await r.json();
				dispatch({ type: Actions.FETCH_PROFILE, payload: data });
			})
			.catch(r => {
				dispatch({ type: Actions.FETCH_PROFILE, payload: undefined });
			});
	}
};

export const createActionFetchProfiles = (options: IPageOptions) => {
	return (dispatch: any) => {
		dispatch(createActionRequest());
		service.fetchPage(options.page, options.size)
			.then(async r  => {
				const res = await r.json();
				dispatch({
					type: Actions.FETCH_PROFILE_LIST,
					payload: res
				})
				dispatch(createActionRequest());
			})
			.catch(e => {
				dispatch(createActionRequest());
			});
	}
}

export default {
	request: createActionRequest,
	fetchProfile: createActionFetchProfile,
}
